import React from 'react';
import { motion } from 'framer-motion';
import { Star, Award, ShieldCheck, ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0a0a0a]" data-id="element-59">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-60">
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/90 to-[#0a0a0a]/60 z-10" data-id="element-61" />
        <img src="https://cdn.magicpatterns.com/uploads/59hM2Dws9qEi3MNm4uuXmK/90a441_6c3b28ed273d40dc84e9cdd6db1997eb~mv2.png" alt="Luxury Sports Car Detail" className="w-full h-full object-cover opacity-60" data-id="element-62" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20" data-id="element-63">
        <div className="max-w-3xl" data-id="element-64">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-65">
            <div className="inline-flex items-center gap-2 px-3 py-1 mb-6 border border-[#d4af37]/30 rounded-full bg-[#d4af37]/10 backdrop-blur-sm" data-id="element-66">
              <Star className="w-4 h-4 text-[#d4af37]" fill="#d4af37" data-id="element-67" />
              <span className="text-[#d4af37] text-xs font-bold tracking-widest uppercase" data-id="element-68">
                Premium Auto Care in Davidsonville
              </span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6 tracking-tight" data-id="element-69">
              Expert Care for <br data-id="element-70" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400" data-id="element-71">
                European & Exotic
              </span>{' '}
              Vehicles
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl" data-id="element-72">
              Specialized service for Land Rover, Jaguar, Mercedes, BMW,
              Porsche, Audi, Ferrari, Lamborghini & more — plus all makes and
              models.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-16" data-id="element-73">
              <a href="#location" className="inline-flex items-center justify-center px-8 py-4 bg-[#c41e3a] text-white font-bold uppercase tracking-wider hover:bg-[#a01830] transition-colors duration-300 rounded-sm group" data-id="element-74">
                Schedule Service
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-75" />
              </a>
              <a href="tel:4107980900" className="inline-flex items-center justify-center px-8 py-4 border border-white/30 text-white font-bold uppercase tracking-wider hover:bg-white hover:text-black transition-all duration-300 rounded-sm backdrop-blur-sm" data-id="element-76">
                Call (410) 798-0900
              </a>
            </div>

            {/* Trust Badges */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 border-t border-white/10 pt-8" data-id="element-77">
              <div className="flex items-center gap-3" data-id="element-78">
                <div className="p-2 bg-white/5 rounded-full" data-id="element-79">
                  <Award className="w-6 h-6 text-[#d4af37]" data-id="element-80" />
                </div>
                <div data-id="element-81">
                  <p className="text-white font-bold" data-id="element-82">25+ Years</p>
                  <p className="text-gray-400 text-sm" data-id="element-83">Experience</p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-84">
                <div className="p-2 bg-white/5 rounded-full" data-id="element-85">
                  <Star className="w-6 h-6 text-[#d4af37]" data-id="element-86" />
                </div>
                <div data-id="element-87">
                  <p className="text-white font-bold" data-id="element-88">5-Star Rated</p>
                  <p className="text-gray-400 text-sm" data-id="element-89">Customer Reviews</p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-90">
                <div className="p-2 bg-white/5 rounded-full" data-id="element-91">
                  <ShieldCheck className="w-6 h-6 text-[#d4af37]" data-id="element-92" />
                </div>
                <div data-id="element-93">
                  <p className="text-white font-bold" data-id="element-94">Certified</p>
                  <p className="text-gray-400 text-sm" data-id="element-95">Master Technicians</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}